import { all } from 'redux-saga/effects';
import criticalAlertsSaga from './criticalAlerts';

export default function* criticalAlertsModuleSaga() {
  yield all([criticalAlertsSaga()]);
}
